module.exports = __webpack_public_path__ + "media/customizations/breezehome/back-39007fb1bae65fd1bcf8c0b623ad61fc.jpg";